import { WithChildren } from 'models/technical/withProps';
import styles from './Games.module.scss';

function GameHint({ children }: WithChildren) {
  return <div className={styles.gameHint}>{children}</div>;
}

export default GameHint;
